import React, { FC } from "react";
import { PartialBrand } from "../../types/types";
import styles from "./Brand.module.scss";

export interface BrandProps {
	content: PartialBrand;
}

export const Brand: FC<BrandProps> = ({
	content: {
		data: { image },
	},
}) => {
	return (
		// <GatsbyImage image={image.fluid} className={styles.image} alt={image.alt} />
		<img
			key={image.url}
			src={image.url}
			alt={image.alt}
			className={styles.logo}
		/>
	);
};
